import "./Register.css";
import React from "react";
import CustomBanner from "components/General/Form/CustomBanner";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import Button from "@material-ui/core/Button";
import AxiosConfig from "axiosConfig";
import * as CONSTANT from "constants/text";
import TextTheme from "components/General/Text/TextTheme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";

class RegisterChildTemp extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			childDetails: [
				{ name: "", nameIssue: "", grade: "", gradeIssue: "", message: "" },
			],
		};
	}

	componentDidMount() {
		if(!sessionStorage.getItem("registerEmail"))
	 	{
			 this.props.history.push("/log-in");
	 	}
	}
	onNameChange(index, event) {
		let childInfo = this.state.childDetails[index];
		childInfo["name"] = event.target.value;
		childInfo["nameIssue"] = "";
		this.state.childDetails[index] = childInfo;
		this.setState({ childDetails: this.state.childDetails });
	}
	onGradeChange(index, event) {
		let childInfo = this.state.childDetails[index];
		childInfo["grade"] = event.target.value;
		childInfo["gradeIssue"] = "";
		this.state.childDetails[index] = childInfo;
		this.setState({ childDetails: this.state.childDetails });
	}
	removeChild(index, event) {
		this.state.childDetails.splice(index, 1);
		this.setState({ childDetails: this.state.childDetails });
	}
	childInfoAddMoreClick() {
		this.setState({
			childDetails: [
				...this.state.childDetails,
				{ name: "", nameIssue: "", grade: "", gradeIssue: "" },
			],
		});
	}
	validate() {
		let flag = true;
		for (let i = 0; i < this.state.childDetails.length; i++) {
			if (this.state.childDetails[i]["name"].trim().length === 0) {
				flag = false;
				this.state.childDetails[i]["nameIssue"] = "Name Missing";
			}
			if (this.state.childDetails[i]["grade"].trim().length === 0) {
				flag = false;
				this.state.childDetails[i]["gradeIssue"] = "Grade Missing";
			}
		}
		this.setState({ childDetails: this.state.childDetails });
		return flag;
	}
	childInfo(option) {
		if (option === "SAVE" && this.validate()===true) {
			let formData = new FormData();
			this.state.childDetails.forEach((item) => {
				formData.append("name", item["name"]);
				formData.append("grade", item["grade"]);
			});
			formData.append("option", option);
			formData.append("email", sessionStorage.getItem("registerEmail"));
			const obj = this;
			return AxiosConfig.post("account/basic_child/", formData)
				.then(function () {
					window.location.href = 'https://get.katamundi.com/confirmation/';
					obj.setState({ message: CONSTANT.USER_REGISTRATION_SUCCESS });
				})
				.catch();
		} else if (option === "SKIP" ) {
			sessionStorage.removeItem("registerEmail");
			sessionStorage.removeItem("registerName");
			window.location.href = 'https://get.katamundi.com/confirmation/';
			this.setState({ message: CONSTANT.USER_REGISTRATION_SUCCESS });
		}
	}
	render() {
		return (
			<div>
				<CustomBanner message="Do you have a child you would like to enroll?" />
				<div style={{ textAlign: "-webkit-center" }}>
					<div className="form_register">
						<h5 className="subtitle">
					<TextTheme
						message="3. Add children that you would like to enroll."
						className="text_medium text_dark_blue"
					/>
						</h5>
						<table>
							<tbody>
								{this.state.childDetails.map((child, index) => {
									return (
										<tr key={index}>
											<td style={{ width: "40%" }}>
												<div>
													<input
														name="name"
														placeholder="Name"
														value={child.name}
														onChange={this.onNameChange.bind(this, index)}
														className="form-control"
													/>
													<div
														className="invalid-feedback"
														style={{
															display: "block",
															textAlign: "left",
															height: "25px",
														}}
													>
														{child.nameIssue}
													</div>
												</div>
											</td>
											<td>
												<div>
													<select
														name="schoolGrade"
														value={child.grade}
														className="form-control"
														onChange={this.onGradeChange.bind(this, index)}
													>
														<option value="" disabled>
															{"School Grade"}
														</option>
														<option value="&lt;TK"> &lt;TK </option>
														<option value="Kindergarten">Kindergarten</option>
														<option value="Grade 1">Grade 1</option>
														<option value="Grade 2">Grade 2</option>
														<option value="Grade 3">Grade 3</option>
														<option value="Grade 4">Grade 4</option>
														<option value="Grade 5">Grade 5</option>
														<option value="Grade 6">Grade 6</option>
														<option value="Other">Other</option>
													</select>
												</div>
												<div
													className="invalid-feedback"
													style={{
														display: "block",
														textAlign: "left",
														height: "25px",
													}}
												>
													{child.gradeIssue}
												</div>
											</td>
											<td style={{ width: "10%" }}>
												{index !== 0 ? (
													<Button
														size="medium"
														variant="outlined"
														onClick={this.removeChild.bind(this, index)}
														style={{
															borderRadius: "20px 20px 20px 20px",
															backgroundColor: "#FF431B",
															minWidth: "10px",
															marginBottom: "30px",
															height: "30px",
														}}
													>
														<FontAwesomeIcon color="white" icon={faTimes} />
													</Button>
												) : (
													<Button
														size="medium"
														variant="outlined"
														onClick={this.childInfoAddMoreClick.bind(this)}
														style={{
															borderRadius: "20px 20px 20px 20px",
															backgroundColor: "#30AFC8",
															minWidth: "10px",
															marginBottom: "30px",
															height: "30px",
														}}
													>
														<FontAwesomeIcon color="white" icon={faPlus} />
													</Button>
												)}
											</td>
										</tr>
									);
								})}
							</tbody>
						</table>
						<div className="onboarding_button_options">
							<div style={{ display: "flex" }}>
								<div style={{ marginLeft: "auto" }}>
									<RoundedButton
										title="&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;"
										buttonClassName="background_dark_orange"
										textThemeClassName="text_medium text_white"
										handleOnClick={this.childInfo.bind(this, "SAVE")}
									/>
									<RoundedButton
										title="Skip for now, maybe later."
										buttonClassName="background_white"
										textThemeClassName="text_medium text_dark_orange"
										handleOnClick={this.childInfo.bind(this, "SKIP")}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div
					style={{
						textAlign: "center",
						width: "100%",
						marginTop: "10px",
						padding: "5px",
					}}
				>
					{this.state.message ? (
						<TextTheme
							message={this.state.message}
							className="text_small text_red"
						/>
					) : null}
				</div>
			</div>
		);
	}
}
export default RegisterChildTemp;